import React from "react";
import AccountStatusBadge from "./AccountStatusBadge";
import ResponsiveAccountTable from "./ResponsiveAccountTable";
import UserManagementDateTime from "./UserManagementDateTime";
import ProtectedProfileImage from "./ProtectedProfileImage";

const RegistrationReviewPerson = ({ type, accountId, image, name, subtitle, imageLabel }) => (
    <span className="registration-review-person">
      <ProtectedProfileImage
        type={type}
        accountId={accountId}
        available={Boolean(image)}
        name={name}
        imageLabel={imageLabel}
        className="registration-review-person-image"
      />
      <span className="registration-review-person-copy">
        <strong>{name}</strong>
        {subtitle && <small>{subtitle}</small>}
      </span>
    </span>
  );

const RegistrationReviewEmail = ({ email, owner }) => (
  <span className="registration-review-person-copy registration-review-email-copy">
    <strong>{email || "—"}</strong>
    {owner && <small>{owner}</small>}
  </span>
);

const RegistrationReviewTable = ({
  type,
  items,
  loading,
  onReview,
  text,
  language,
  filtered = false
}) => {
  const customer = type === "customers";
  const statusLabel = (status) =>
    ({
      PENDING_REVIEW: text.pending,
      REUPLOAD_REQUIRED: text.reupload,
      REJECTED: text.rejected,
      APPROVED: text.approved
    })[status] || status || "—";

  const columns = [
      {
        key: "name",
        label: customer ? text.customerName : text.storeName,
        width: "24%",
        className: "registration-review-col-name",
        render: (row) => {
          const name = customer
            ? row.fullName || row.name || "—"
            : row.nameAr || row.name || row.nameEn || "—";
          return (
            <RegistrationReviewPerson
              type={type}
              accountId={row.id || row._id}
              image={row.profileImageAvailable || row.profileImage}
              name={name}
              subtitle={
                customer || !row.nameEn || row.nameEn === name
                  ? ""
                  : row.nameEn
              }
              imageLabel={text.profileImage}
            />
          );
        }
      },
      {
        key: "email",
        label: text.email,
        width: "25%",
        className: "registration-review-col-email",
        render: (row) => (
          <RegistrationReviewEmail
            email={row.email}
            owner={customer ? "" : row.ownerFullLegalName}
          />
        )
      },
      {
        key: "identifier",
        label: text.phone,
        width: "12%",
        className: "registration-review-col-phone",
        render: (row) => row.phone || "—"
      },
      {
        key: "registeredAt",
        label: text.registrationDate,
        width: "16%",
        className: "registration-review-col-date",
        render: (row) => <UserManagementDateTime value={row.registeredAt} language={language} />
      },
      {
        key: "reviewStatus",
        label: text.reviewStatus,
        width: "13%",
        className: "registration-review-col-status",
        render: (row) => (
          <AccountStatusBadge
            status={row.reviewStatus}
            label={statusLabel(row.reviewStatus)}
          />
        )
      }
    ];

  return (
    <ResponsiveAccountTable
      columns={columns}
      rows={items}
      loading={loading}
      onOpen={(row) => onReview(row.id || row._id)}
      actionLabel={text.review}
      actionIcon="fa-arrow-right"
      emptyLabel={filtered ? text.noRegistrationReviews : text.noQueuedRegistrations}
      emptyHint={filtered ? text.noFilterMatchesHint : text.noQueuedRegistrationsHint}
      tableClassName="registration-review-table"
    />
  );
};

export default RegistrationReviewTable;
